export default __webpack_public_path__ + "assets/img/dots-black.png";